var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanva(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H4C1.791 0 0 1.791 0 4V40C0 42.209 1.791 44 4 44H40C42.209 44 44 42.209 44 40V4C44 1.791 42.209 0 40 0Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4511 29.953C28.9731 31.312 28.0131 32.246 25.8631 33.345C24.6311 33.96 23.2461 34.33 21.9391 34.33C18.0181 34.33 16.1061 30.72 15.7251 27.602C14.7481 19.603 21.7771 8.60804 26.6781 8.60804C27.8211 8.60804 28.8421 9.60204 29.0321 11.151C29.3261 13.562 29.2781 15.271 26.7851 17.354C26.5121 17.581 26.4321 17.95 26.5731 18.168C26.7851 18.494 27.4551 18.527 28.8091 17.842C31.4611 16.504 32.4171 14.438 32.1251 12.046C31.8001 9.39204 29.4841 7.17004 26.3781 7.17004C24.8681 7.17004 23.2071 7.62104 21.7241 8.52404C15.2611 12.461 11.0911 21.445 11.9291 28.297C12.1941 30.471 13.0981 32.851 14.8051 34.451C15.9561 35.517 18.0361 36.83 20.4881 36.83C23.1431 36.83 25.3851 35.805 27.3961 34.536C28.7591 33.663 29.8991 32.607 30.8621 31.526C32.4411 30.058 31.3051 29.147 30.4511 29.953Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 42.984,
    y1: 45.143,
    x2: 1.623,
    y2: -0.474002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#823AF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#4B66E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#01F1C4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanva);
export default __webpack_public_path__ + "static/media/canva.de8f972e2e606d03c9cd976cc94fbfdd.svg";
export { ForwardRef as ReactComponent };